import LoadingIndicator from 'dashboard/components-lib/LoadingIndicator';
import { CaseAnalyticsTagDistribution } from 'dashboard/models/case-analytics';
import CaseTagDistributionChart from 'dashboard/views/DashboardCaseAnalyticsResolutionsView/CaseTagDistributionChart';
import Card from 'design-system/components/Card';

export interface CaseTagDistributionCardProps extends CaseAnalyticsTagDistribution {
  loading: boolean;
}

const CaseTagDistributionCard = ({
  data,
  domain,
  period,
  loading,
}: CaseTagDistributionCardProps) => {
  return (
    <Card>
      <Card.Body>
        <Card.Title>Case tag distribution</Card.Title>
        {loading ? (
          <LoadingIndicator />
        ) : (
          <CaseTagDistributionChart data={data} domain={domain} period={period} />
        )}
      </Card.Body>
    </Card>
  );
};

export default CaseTagDistributionCard;
